export const setTheming = theming => {
    if (!theming) return

    const { colors, fonts, images } = theming

    if (colors) mapAndApplyStyles(colors)
    if (fonts) mapAndApplyStyles(fonts)
    if (images) mapAndApplyImages(images)
}

const mapAndApplyStyles = styles => {
    if (!styles) return

    Object.entries(styles).forEach(([key, value]) => {
        if (value) {
            document.documentElement.style.setProperty(`--${key}`, value)
        }
    })
}

const mapAndApplyImages = images => {
    if (!images) return

    Object.entries(images).forEach(([key, value]) => {
        if (value) {
            document.documentElement.style.setProperty(`--${key}`, `url(${value})`)
        }
    })
}
